import { Grid } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import { Col, Row, Spinner } from "react-bootstrap";
import DatePicker from "react-date-picker";
import "react-datepicker/dist/react-datepicker.css";
import { vasthuUrl } from "../component/Api";
import NewBootCard from "../component/NewBootCard";

const PaymentDateHistory = () => {
  const token = sessionStorage.getItem("token");
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [clientData, setClientData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const today = new Date();

  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    d.setHours(12, 0, 0, 0);
    return d.toISOString().split("T")[0];
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        let url = "/vasthu/getAllPayment";
        let params = {};

        if (startDate && endDate && startDate <= endDate) {
          url = "/vasthu/getAllPaymentsByDate";
          params = {
            startDate: formatDate(startDate),
            endDate: formatDate(endDate),
          };
        }

        const res = await vasthuUrl.get(url, {
          headers: { Authorization: `Bearer ${token}` },
          params,
        });

        setClientData(res.data || []);
      } catch (err) {
        console.error("Error fetching data:", err);
        setError("Unable to fetch payment data. Please try again.");
        setClientData([]);
      } finally {
        setLoading(false);
      }
    };

    // Trigger API only if both dates are valid or both are empty
    if (
      (startDate && endDate && startDate <= endDate) ||
      (!startDate && !endDate)
    ) {
      fetchData();
    }
  }, [startDate, endDate, token]);

  const columns = [
    { field: "offerName", headerName: "Offer Name", width: 150 },
    { field: "txnAmount", headerName: "Transaction Amount", width: 150 },
    { field: "userName", headerName: "User Name", width: 140 },
    { field: "bankName", headerName: "Bank Name", width: 100 },
    { field: "orderId", headerName: "Order ID", width: 150 },
    { field: "status", headerName: "Status", width: 100 },
  ];

  return (
    <div>
      {/* Date Filters */}
      <div className="admindate_history">
        <Row className="mt-2 consul_chat_his" style={{ display: "flex" }}>
          <Col className="mt-2">
            <label className="d-flex flex-column">
              Start Date:
              <DatePicker
                className="form_feild"
                value={startDate}
                format="dd-MM-yy"
                onChange={setStartDate}
                maxDate={endDate || today}
              />
            </label>
          </Col>
          <Col className="mt-2">
            <label className="d-flex flex-column">
              End Date:
              <DatePicker
                className="form_feild"
                value={endDate}
                format="dd-MM-yy"
                onChange={setEndDate}
                minDate={startDate}
                maxDate={today}
              />
            </label>
          </Col>
        </Row>
      </div>

      {/* Date Range Summary */}
      <div style={{ display: "flex", justifyContent: "center" }}>
        {(startDate || endDate) && (
          <h4 className="text-muted mt-1">
            (
            {startDate
              ? new Date(startDate).toLocaleDateString("en-IN")
              : "Start Date"}{" "}
            to{" "}
            {endDate
              ? new Date(endDate).toLocaleDateString("en-IN")
              : "End Date"}
            )
          </h4>
        )}
      </div>

      {/* Optional: Warn if only one date is selected */}
      {(startDate && !endDate) || (!startDate && endDate) ? (
        <div className="text-danger text-center mt-2">
          Please select both Start and End Date to filter payments.
        </div>
      ) : null}

      {/* Data Display */}
      <center className="datagrid mt-3">
        <h2 className="text-center">Payment History</h2>
        <Grid container className="deskTable datagrid">
          {loading ? (
            <div className="text-center w-100 mt-5">
              <Spinner animation="border" variant="warning" />
            </div>
          ) : error ? (
            <div className="text-center text-danger w-100 mt-4">{error}</div>
          ) : clientData?.transactions?.length > 0 ? (
            <div className="d-flex flex-column">
              <h2 className="text-center">
                Total Amount : Rs.{clientData?.totalEarnedAmount}
              </h2>
              <DataGrid
                className="all_border text-center data_grid"
                rows={clientData?.transactions}
                columns={columns}
                pageSizeOptions={[5, 10]}
                initialState={{
                  pagination: { paginationModel: { page: 0, pageSize: 10 } },
                }}
                getRowId={(row) => row.orderId}
                autoHeight
              />
            </div>
          ) : (
            <div className="text-center w-100 mt-5">
              <p>No payment data available.</p>
            </div>
          )}
        </Grid>
      </center>

      {/* Mobile View */}
      <div className="mobileCard justify-content-center mx-1">
        {loading ? (
          <div className="text-center w-100 mt-5">
            <Spinner animation="border" variant="warning" />
          </div>
        ) : (
          <h4 className="text-center">
            Total Amount : Rs.{clientData?.totalEarnedAmount}
          </h4>
        )}
        {clientData?.transactions?.map((item, index) => (
          <NewBootCard key={index}>
            <h6>Offer Name: {item.offerName}</h6>
            <h6>Transaction Amount: {item.txnAmount}</h6>
            <h6>User Name: {item.userName}</h6>
            <h6>Bank Name: {item.bankName}</h6>
            <h6>Order ID: {item.orderId}</h6>
            <h6>Status: {item.status}</h6>
          </NewBootCard>
        ))}
      </div>
    </div>
  );
};

export default PaymentDateHistory;
